<template>
  <el-form
    :model="form"
    :disabled="disabledForm"
    class="form-insert"
    ref="form">
    <div class="row">
      <div class="col-lg-4 col-md-3 col-sm-4 col-8">
        <el-form-item
          :label="L10n('part-number')"
          prop="partID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-part-number
            :model="form.partID"
            disabled
          >
          </select-part-number>
        </el-form-item>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 col-4">
        <el-form-item
          :label="L10n('qty')"
          :rules="getValidationRule('required,numberInteger')"
          prop="qty"
          class="material-style">
          <el-input
            :value="form.qty"
            @input="form.qty = valueNumber($event)"/>
        </el-form-item>
      </div>
      <div class="col-lg-4 col-md-3 col-sm-3 col-12">
        <el-form-item
          :label="L10n('observation')"
          prop="observation"
          class="material-style">
          <el-input
            v-model="form.observation"
          ></el-input>
        </el-form-item>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-3 col-12 d-flex justify-content-center align-items-center">
        <ui-button
          type="button"
          class="btn btn-size-s btn-mobile-full"
          :disabled="disabledForm"
          @click="$emit('onAddToQuote', form)"
        >{{L10n('add-to-quote')}}</ui-button>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormManually',
  components: {
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue')
  },
  mixins: [Form]
}
</script>
